import type { FC } from 'react';
import styles from './SimplePanels.module.scss';

const DiscountsPanel: FC = () => {
    return (
        <div className={styles.wrapper}>
            <h2 className={styles.title}>Мои скидки</h2>
            <span style={{ color: 'silver' }}>Сейчас персональных скидок нет. Если появятся - покажем их здесь.</span>
        </div>
    );
};

export default DiscountsPanel;
